import axios from 'axios'

class NetworkOnly {
  /**
   * @param {Object} options
   */
  constructor(options) {
    this._networkTimeoutSeconds = options.networkTimeoutSeconds || 0
    this.time = null
  }

  /**
   * @param {String} url
   * @return {Promise}
   */
  static handle(url) {
    const net = new NetworkOnly({ networkTimeoutSeconds: this._networkTimeoutSeconds })

    return net._handle(url)
  }

  /**
   * @param {String} url
   * @return {Promise}
   */
  _handle(url) {
    const _this = this
    const promise = new Promise(resolve => {
      _this.time = setTimeout(async () => {
        const promise = await axios.get(url).catch(() => {
          return false
        })
        if (promise && promise.status !== undefined && promise.status === 200) {
          clearTimeout(_this.time)
          resolve(true)
        }
        if (promise === false) {
          clearTimeout(_this.time)
          resolve(false)
        }
      }, _this._networkTimeoutSeconds * 1000)
    })

    return promise
  }
}

export { NetworkOnly }
